import React from 'react';
import { Message, Icon } from 'semantic-ui-react';

const Loading = ({ resource }) => (
  <Message icon color="teal">
    <Icon name='circle notched' loading />
    <Message.Content>
      <Message.Header>Just one second</Message.Header>
      We are fetching your {resource}
    </Message.Content>
  </Message>
)

export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading/index.js